import { apiClient, type RequestOptions } from '@/services/apiClient';
import type { SeedDataCommandCenter, SeedDomainKey, SeedScale } from './seedData.types';
export interface SeedExpansionInput { domains?: SeedDomainKey[]; batchSize?: number; scale?: SeedScale }
export const seedDataApi = {
  getDashboard: (options?: RequestOptions) => apiClient.get<SeedDataCommandCenter>('/v1/seed-data/command-center', options),
  expand: (input: SeedExpansionInput, options?: RequestOptions) => apiClient.post<SeedDataCommandCenter['runs'][number]>('/v1/seed-data/expand', input, options),
};
